<div class="best-job">
  <img
    *ngIf="showCrown"
    src="assets/images/label-mojo-crown.png"
  >
  <span>BEST JOB</span>
</div>
